import {Middleware} from '@reduxjs/toolkit'
import {LOCATION_CHANGE} from 'redux-first-history'

import {makeReplaceName} from '@shared/helpers/format'

import {ROUTER_ORDER_SALE_SETTLEMENT} from '@web/core/routes'
import {Sentry} from '@web/helpers/log'

const orderNo = '[0-9]{16}'

const getTransactionName = makeReplaceName([
    [`${ROUTER_ORDER_SALE_SETTLEMENT.DETAIL}/${orderNo}`, `${ROUTER_ORDER_SALE_SETTLEMENT.DETAIL}/{orderNo}`],
])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sentryTransaction: Middleware = () => (next) => (action: any) => {
    next(action)

    if (action.type === LOCATION_CHANGE) {
        Sentry.setTransactionName(getTransactionName(window.location.pathname))
    }
}

export default sentryTransaction
